/**
 * Infinite Scroll for Collection Pages
 * Uses IntersectionObserver to lazy-load next page products.
 */
(function () {
  'use strict';

  var container = document.querySelector('.infinite-scroll');
  if (!container) return;

  var grid = document.querySelector('.collection-grid');
  if (!grid) return;

  var spinner = container.querySelector('.infinite-scroll__spinner');
  var nextUrl = container.getAttribute('data-next-url');
  var loading = false;

  if (container.hasAttribute('data-no-more') || !nextUrl) return;

  function loadMore() {
    if (loading || !nextUrl) return;
    loading = true;
    if (spinner) spinner.style.display = '';

    fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* Extract product cards from the fetched page */
        var newGrid = doc.querySelector('.collection-grid');
        if (newGrid) {
          var cards = newGrid.children;
          var fragment = document.createDocumentFragment();
          while (cards.length > 0) {
            fragment.appendChild(cards[0]);
          }
          grid.appendChild(fragment);
        }

        /* Check for next page */
        var newContainer = doc.querySelector('.infinite-scroll');
        if (newContainer && newContainer.getAttribute('data-next-url') && !newContainer.hasAttribute('data-no-more')) {
          nextUrl = newContainer.getAttribute('data-next-url');
        } else {
          nextUrl = null;
          container.style.display = 'none';
        }

        loading = false;
        if (spinner) spinner.style.display = 'none';

        /* Re-init reveal animations for new cards */
        if (typeof IntersectionObserver !== 'undefined') {
          var reveals = grid.querySelectorAll('.reveal:not(.revealed)');
          if (reveals.length > 0 && window._revealObserver) {
            reveals.forEach(function (el) { window._revealObserver.observe(el); });
          } else {
            reveals.forEach(function (el) { el.classList.add('revealed'); });
          }
        }
      })
      .catch(function () {
        loading = false;
        if (spinner) spinner.style.display = 'none';
      });
  }

  /* Observe the trigger element */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    observer.observe(container);
  } else {
    /* Fallback: scroll event for old browsers */
    var throttle = false;
    window.addEventListener('scroll', function () {
      if (throttle) return;
      throttle = true;
      requestAnimationFrame(function () {
        var rect = container.getBoundingClientRect();
        if (rect.top < window.innerHeight + 400) {
          loadMore();
        }
        throttle = false;
      });
    });
  }
})();
